var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EditableDataGrid } from "../../../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../../../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiPopup, MuiStack } from "../../../../../../../components";
import { LOCAL_STORAGE_KEYS } from "../../../../../../../constants";
import { useAppSelector } from "../../../../../../../store/hooks";
import { systemColor } from "../../../../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../../../../utils/storageHelper";
import { getAvailableQtyByWarehouse } from "../../../../../../stockTransfer/apiCall";
import PartInfoTooltip from "../../../../../purchaseRequistion/components/partInfoTooltip";
import { procurementPriorityListAPICall, searchByProductCodeAndNameAPICall } from "../../../../../purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../../../../purchaseRequistion/services/entity";
import { generateCodeName } from "../../../../../purchaseRequistion/utils/utils";
import { availableQuantityByWarehouseAPICall, productPriceDetailsAPICall, UOMDetailsByProductIdAPICall } from "../services/apiCall";
import { InterWarehouseTransferRequisitionKeys } from "../services/entity";
import { MultipleLocationsPopup } from "./multipleLocationsPopup";
import WarehouseCell from "./warehouseCell";
var PartDetailsWtoW = function (props) {
    var _value$name, _getLocalStorageItem, _props$value, _props$value2, _value$StockTransferR;
    var searchParams = useSearchParams()[0];
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'StockTransferRequisitionDetail' : _a;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _b = useState(), modalProps = _b[0], setModalProps = _b[1];
    var rows = (_value$name = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name !== void 0 ? _value$name : [];
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var sourceWarehouseId = props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.SourceWarehouseId;
    var destinationWarehouseId = props === null || props === void 0 || (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.DestinationWarehouseId;
    useEffect(function () {
        procurementPriorityListAPICall({});
    }, []);
    var getPartListByPagination = function (params) { return searchByProductCodeAndNameAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            skip: 0,
            take: 10
        }, params.request)
    })); };
    var totalsRow = useMemo(function () {
        var totals = {
            id: RowModeIds.Total,
            Product: 'Total',
            TotalCost: 0,
            DestinationLocations: null,
            SourceLocations: null
        };
        rows.forEach(function (r) {
            if (r.id === RowModeIds.Total)
                return;
            if (r !== null && r !== void 0 && r.PurchasePrice && r !== null && r !== void 0 && r.RequestedQuantity)
                totals.TotalCost = totals.TotalCost + (r === null || r === void 0 ? void 0 : r.PurchasePrice) * (r === null || r === void 0 ? void 0 : r.RequestedQuantity);
        });
        return totals;
    }, [rows]);
    var sourceLocation = [{
            field: 'LocationName',
            headerName: 'Storage location ',
            editable: false,
            flex: 1,
            width: 300
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            width: 300
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Requested Transfer Qty',
            editable: true,
            flex: 1,
            width: 300
        }];
    var destinationLocation = [{
            field: 'LocationName',
            headerName: 'Storage location ',
            editable: false,
            flex: 1,
            width: 300
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            width: 300
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Transfer Qty',
            editable: true,
            flex: 1,
            width: 300
        }];
    var columns = [{
            type: 'searchSelect',
            field: 'Product',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            minWidth: 250,
            getListData: getPartListByPagination,
            apiKey: PurchaseRequisitionKeys.PartListByName,
            placeholder: 'Search Part by name',
            moreButtonText: 'Search More...',
            getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) + " | " + (option === null || option === void 0 ? void 0 : option.SkuCode); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Product: value,
                ProductId: value === null || value === void 0 ? void 0 : value.id,
                ProductCode: value === null || value === void 0 ? void 0 : value.SkuCode,
                ProductName: value === null || value === void 0 ? void 0 : value.Name
            }); },
            renderOption: function (props, option) {
                return /*#__PURE__*/ React.createElement(MenuItem, props, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '200px'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        overflow: "hidden",
                        whiteSpace: 'wrap',
                        textOverflow: 'ellipsis'
                    }
                }, option === null || option === void 0 ? void 0 : option.Name)), /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '100px',
                    borderLeft: "1px solid ".concat(systemColor.grey),
                    paddingX: 2
                }, /*#__PURE__*/ React.createElement(Typography, null, option === null || option === void 0 ? void 0 : option.SkuCode)));
            },
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.ProductName ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ProductName) : ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ProductCode ? "#".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ProductCode) : ""));
            }
        }, {
            field: 'UOM',
            headerName: 'UOM',
            flex: 1,
            placeholder: "Select UOM",
            minWidth: 150
        }, {
            type: 'number',
            field: 'MRP',
            headerName: 'MRP (₹)',
            flex: 1,
            minWidth: 150
        }, {
            type: 'number',
            field: 'PurchasePrice',
            headerName: 'Purchase Price (₹)',
            flex: 1,
            minWidth: 150
        }, {
            type: 'number',
            field: 'AvailableQuantity',
            headerName: 'Available Quantity',
            editable: false,
            flex: 1,
            minWidth: 150
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Requested Transfer Qty',
            editable: true,
            flex: 1,
            minWidth: 150
        }, {
            field: 'SourceLocations',
            headerName: 'Storage location (S)',
            editable: false,
            flex: 1,
            minWidth: 150,
            getOptionLabel: function (value) { return generateCodeName(value, 'Code', 'DisplayName'); },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            renderCell: function (params) {
                var _params$row9, _params$row10;
                if (params.id === RowModeIds.Total)
                    return;
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$name2;
                    var filteredData = rows === null || rows === void 0 ? void 0 : rows.filter(function (item) { return selectedRows.includes(item === null || item === void 0 ? void 0 : item.id); });
                    var transformedData = filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        AvailableQuantity: item.QuantityAvailable
                    }); });
                    var newRows = (_value$name2 = value[name]) === null || _value$name2 === void 0 ? void 0 : _value$name2.map(function (r) {
                        var _params$row5;
                        return (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            SourceLocations: transformedData
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                };
                var getSourceLocations = function (apiParams) { return __awaiter(void 0, void 0, void 0, function () {
                    var _res$data, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAvailableQtyByWarehouse(apiParams)];
                            case 1:
                                res = _a.sent();
                                data = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.map(function (r) {
                                    var _params$row$SourceLoc, _params$row$SourceLoc2;
                                    return (_params$row$SourceLoc = (_params$row$SourceLoc2 = params.row.SourceLocations) === null || _params$row$SourceLoc2 === void 0 ? void 0 : _params$row$SourceLoc2.find(function (it) { return it.id === r.id; })) !== null && _params$row$SourceLoc !== void 0 ? _params$row$SourceLoc : r;
                                });
                                return [2 /*return*/, {
                                        data: data,
                                        success: true
                                    }];
                        }
                    });
                }); };
                var onsourceLocationClick = function () {
                    var _crud$profilePersonal, _params$row6, _params$row7, _params$row8;
                    var modalProps = {
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.Branches[0]) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.OrganizationId,
                            ProductId: params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ProductId,
                            WarehouseId: sourceWarehouseId
                        },
                        apiCall: getSourceLocations,
                        apiKey: 'getAvailableQty',
                        columns: sourceLocation,
                        title: t('Source location'),
                        data: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.SourceLocations,
                        singleSelection: true,
                        rowData: params.row,
                        selectedRows: (params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 || (_params$row8 = _params$row8.SourceLocations) === null || _params$row8 === void 0 ? void 0 : _params$row8.map(function (e) { return e === null || e === void 0 ? void 0 : e.id; })) || []
                    };
                    setModalProps(modalProps);
                };
                if (params !== null && params !== void 0 && (_params$row9 = params.row) !== null && _params$row9 !== void 0 && _params$row9.Product || params !== null && params !== void 0 && (_params$row10 = params.row) !== null && _params$row10 !== void 0 && _params$row10.ProductId) {
                    var _params$row11;
                    return /*#__PURE__*/ React.createElement(WarehouseCell, _extends({}, params, {
                        onButtonClick: onsourceLocationClick,
                        rowData: params === null || params === void 0 || (_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.SourceLocations
                    }));
                }
                else {
                    return /*#__PURE__*/ React.createElement(React.Fragment, null);
                }
            }
        }, {
            field: 'DestinationLocations',
            headerName: 'Storage location (D)',
            editable: true,
            flex: 1,
            minWidth: 150,
            renderCell: function (params) {
                var _params$row16, _params$row17;
                if (params.id === RowModeIds.Total)
                    return;
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$name3;
                    var filteredData = rows === null || rows === void 0 ? void 0 : rows.filter(function (item) { return selectedRows.includes(item === null || item === void 0 ? void 0 : item.id); });
                    var transformedData = filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        AvailableQuantity: item.QuantityAvailable
                    }); });
                    var newRows = (_value$name3 = value[name]) === null || _value$name3 === void 0 ? void 0 : _value$name3.map(function (r) {
                        var _params$row12;
                        return (params === null || params === void 0 || (_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            DestinationLocations: transformedData
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                };
                var getDestinationLocation = function (apiParams) { return __awaiter(void 0, void 0, void 0, function () {
                    var _res$data2, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAvailableQtyByWarehouse(apiParams)];
                            case 1:
                                res = _a.sent();
                                data = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.map(function (r) {
                                    var _params$row$Destinati, _params$row$Destinati2;
                                    return (_params$row$Destinati = (_params$row$Destinati2 = params.row.DestinationLocations) === null || _params$row$Destinati2 === void 0 ? void 0 : _params$row$Destinati2.find(function (it) { return it.id === r.id; })) !== null && _params$row$Destinati !== void 0 ? _params$row$Destinati : r;
                                });
                                return [2 /*return*/, {
                                        data: data,
                                        success: true
                                    }];
                        }
                    });
                }); };
                var onDestinationLocationClick = function () {
                    var _crud$profilePersonal2, _params$row13, _params$row14, _params$row15;
                    var modalProps = {
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.Branches[0]) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.OrganizationId,
                            ProductId: params === null || params === void 0 || (_params$row13 = params.row) === null || _params$row13 === void 0 ? void 0 : _params$row13.ProductId,
                            WarehouseId: destinationWarehouseId
                        },
                        apiCall: getDestinationLocation,
                        apiKey: 'getAvailableQty',
                        columns: destinationLocation,
                        title: t('Destination location'),
                        data: params === null || params === void 0 || (_params$row14 = params.row) === null || _params$row14 === void 0 ? void 0 : _params$row14.DestinationLocations,
                        singleSelection: true,
                        rowData: params.row,
                        selectedRows: (params === null || params === void 0 || (_params$row15 = params.row) === null || _params$row15 === void 0 || (_params$row15 = _params$row15.DestinationLocations) === null || _params$row15 === void 0 ? void 0 : _params$row15.map(function (e) { return e === null || e === void 0 ? void 0 : e.id; })) || []
                    };
                    setModalProps(modalProps);
                };
                if (params !== null && params !== void 0 && (_params$row16 = params.row) !== null && _params$row16 !== void 0 && _params$row16.Product || params !== null && params !== void 0 && (_params$row17 = params.row) !== null && _params$row17 !== void 0 && _params$row17.ProductId) {
                    var _params$row18;
                    return /*#__PURE__*/ React.createElement(WarehouseCell, _extends({}, params, {
                        onButtonClick: onDestinationLocationClick,
                        rowData: params === null || params === void 0 || (_params$row18 = params.row) === null || _params$row18 === void 0 ? void 0 : _params$row18.DestinationLocations
                    }));
                }
                else {
                    return /*#__PURE__*/ React.createElement(React.Fragment, null);
                }
            }
        }, {
            type: 'number',
            field: 'TotalCost',
            headerName: 'Total Cost (₹)',
            editable: false,
            flex: 1,
            placeholder: '00.00',
            minWidth: 150,
            valueGetter: function (value, row) {
                var _row$RequestedQuantit, _row$PurchasePrice;
                return row !== null && row !== void 0 && row.RequestedQuantity || row !== null && row !== void 0 && row.PurchasePrice ? ((_row$RequestedQuantit = row === null || row === void 0 ? void 0 : row.RequestedQuantity) !== null && _row$RequestedQuantit !== void 0 ? _row$RequestedQuantit : 0) * ((_row$PurchasePrice = row === null || row === void 0 ? void 0 : row.PurchasePrice) !== null && _row$PurchasePrice !== void 0 ? _row$PurchasePrice : 0) : value;
            }
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            placeholder: "Enter remarks",
            minWidth: 250
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableAddRow: false,
        dataGridHeader: "Part details",
        dataGridProps: {
            rowSelection: true,
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            isCellEditable: function (params) {
                return !(params.id == RowModeIds.Total);
            },
            getRowHeight: function (params) {
                return params.id === RowModeIds.Aggregation ? 44 : undefined;
            },
            processRowUpdate: function (newRow, oldRow) { return __awaiter(void 0, void 0, void 0, function () {
                var row, _priceDetails$SaleMRP, _priceDetails$Purchas, _UOMdetails$data, _UOMdetails$data2, UOMdetails, quantities, priceDetails;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            row = newRow;
                            if (!((newRow === null || newRow === void 0 ? void 0 : newRow.ProductId) !== (oldRow === null || oldRow === void 0 ? void 0 : oldRow.ProductId))) return [3 /*break*/, 4];
                            return [4 /*yield*/, UOMDetailsByProductIdAPICall({
                                    request: {
                                        TenantId: UserOrganization,
                                        ProductId: newRow === null || newRow === void 0 ? void 0 : newRow.ProductId
                                    }
                                })];
                        case 1:
                            UOMdetails = _a.sent();
                            return [4 /*yield*/, availableQuantityByWarehouseAPICall({
                                    request: {
                                        TenantId: UserOrganization,
                                        ProductId: newRow === null || newRow === void 0 ? void 0 : newRow.ProductId,
                                        WarehouseId: value === null || value === void 0 ? void 0 : value.SourceWarehouseId
                                    }
                                })];
                        case 2:
                            quantities = _a.sent();
                            return [4 /*yield*/, productPriceDetailsAPICall({
                                    request: {
                                        TenantId: UserOrganization,
                                        ProductId: newRow === null || newRow === void 0 ? void 0 : newRow.ProductId,
                                        WarehouseId: value === null || value === void 0 ? void 0 : value.SourceWarehouseId
                                    }
                                })];
                        case 3:
                            priceDetails = _a.sent();
                            row = _objectSpread(_objectSpread({}, newRow), {}, {
                                MRP: priceDetails === null || priceDetails === void 0 || (_priceDetails$SaleMRP = priceDetails.SaleMRP) === null || _priceDetails$SaleMRP === void 0 ? void 0 : _priceDetails$SaleMRP.Price,
                                PurchasePrice: priceDetails === null || priceDetails === void 0 || (_priceDetails$Purchas = priceDetails.PurchaseBasePrice) === null || _priceDetails$Purchas === void 0 ? void 0 : _priceDetails$Purchas.Price,
                                UnitOfMeasurementId: UOMdetails === null || UOMdetails === void 0 || (_UOMdetails$data = UOMdetails.data) === null || _UOMdetails$data === void 0 ? void 0 : _UOMdetails$data.UnitOfMeasurementId,
                                UOM: UOMdetails === null || UOMdetails === void 0 || (_UOMdetails$data2 = UOMdetails.data) === null || _UOMdetails$data2 === void 0 ? void 0 : _UOMdetails$data2.UnitOfMeasurementName,
                                AvailableQuantity: quantities === null || quantities === void 0 ? void 0 : quantities.TotalAvailableQuantity
                            });
                            _a.label = 4;
                        case 4: return [2 /*return*/, row];
                    }
                });
            }); },
            initialState: {
                aggregation: {
                    model: {
                        TotalCost: 'sum'
                    }
                }
            }
        },
        rows: (_value$StockTransferR = value.StockTransferRequisitionDetail) !== null && _value$StockTransferR !== void 0 ? _value$StockTransferR : [{
                id: 1
            }],
        validationModel: {
            RequestedQuantity: function (value, row) {
                if (value > row.AvailableQuantity)
                    return "Qty must not exceed than available Qty.";
                if (value < 1)
                    return "Quantity must not go below 1.";
            },
            Product: function (productValue, row, rowsLookup) {
                var _rowsLookup$values;
                if (rowsLookup !== null && rowsLookup !== void 0 && (_rowsLookup$values = rowsLookup.values()) !== null && _rowsLookup$values !== void 0 && (_rowsLookup$values = _rowsLookup$values.toArray()) !== null && _rowsLookup$values !== void 0 && _rowsLookup$values.some(function (it) { return it.ProductId === (productValue === null || productValue === void 0 ? void 0 : productValue.id); }))
                    return "Part already requested.";
            },
            UnitOfMeasurementName: function () {
                var _crud$InterWarehouseT, _crud$InterWarehouseT2;
                if (((_crud$InterWarehouseT = crud[InterWarehouseTransferRequisitionKeys.UOMDetailsByProductId]) === null || _crud$InterWarehouseT === void 0 ? void 0 : _crud$InterWarehouseT.statusCode) === 404)
                    return (_crud$InterWarehouseT2 = crud[InterWarehouseTransferRequisitionKeys.UOMDetailsByProductId]) === null || _crud$InterWarehouseT2 === void 0 ? void 0 : _crud$InterWarehouseT2.message;
            }
        },
        error: error === null || error === void 0 ? void 0 : error['StockTransferRequisitionDetail'],
        cellInfoModel: {
            Product: function () { return value !== null && value !== void 0 && value.Product ? /*#__PURE__*/ React.createElement(PartInfoTooltip, null) : undefined; }
        }
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: true,
        title: modalProps === null || modalProps === void 0 ? void 0 : modalProps.title,
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            paddingTop: 0,
            paddingX: "16px"
        }
    }, modalProps && /*#__PURE__*/ React.createElement(MultipleLocationsPopup, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); }
    }))));
};
export default PartDetailsWtoW;
